/* ===================================================================
   THE FLOAT CLUB — fc-help.js
   The chat bubble, without the chat app.

   Shopify Inbox cannot be installed through any API, so this is the
   same job done in the theme: a launcher bottom-right that opens a
   panel with the answers people actually write in for, plus a direct
   line to a human.

   Why answers first and contact second, rather than a blank chat box:
   a one-person shop cannot man a live chat, and an unanswered chat is
   worse than no chat. Roughly every support message on a product sized
   by measurement is the same question, so the panel answers it inline
   and only escalates what genuinely needs a person.

   Rebuilt for usability. What was wrong with the first version:
     - a bare speech-bubble icon told nobody what it was, or whether a
       human was behind it. It now says HELP on the button.
     - there was no close button. You had to guess at tapping outside
       or pressing Escape, and on a phone neither is obvious.
     - it opened onto five collapsed questions, so the fastest anyone
       could reach an answer was two taps. The four things people
       actually want are now one tap, as links straight to the page.
     - on a phone a small floating card is the wrong shape. It is a
       bottom sheet now, with a grab handle and a scrim.
     - opening it left keyboard focus behind on the page.

   CONFIGURE: set WHATSAPP or EMAIL below. With neither set the launcher
   does not render at all, rather than opening a dead end.
=================================================================== */
(function (global) {
  "use strict";

  var WHATSAPP = "";                       // international, digits only e.g. "447700900123"
  var EMAIL    = "benybenh@gmail.com";     // change to a business inbox before traffic

  if (!WHATSAPP && !EMAIL) return;
  if (/\/(checkouts?)/.test(location.pathname)) return;   // never over checkout

  var open = false, root = null, lastFocus = null;

  /* One tap, straight to the page that answers it. These four are the
     whole of the support inbox on a product sized by measurement. */
  var LINKS = [
    ["Find his size",   "/pages/size-guide"],
    ["Track my order",  "/pages/track-your-order"],
    ["Return or swap",  "/pages/returns"],
    ["Delivery times",  "/pages/shipping"]
  ];

  var FAQ = [
    ["What size does my dog need?",
     "Measure around the widest part of his ribcage, just behind the front legs, snug but not tight. " +
     "XS 12 to 15 in. S 15 to 20 in. M 20 to 26 in. L 26 to 33 in. XL 33 to 42 in. " +
     "Size by that number, not by breed."],
    ["What if I pick the wrong size?",
     "Free swap for 90 days. One per order, you cover return postage and we cover the outbound."],
    ["Can my dog swim in it?",
     "The chin float holds his muzzle clear of the water, which is the part most vests miss. " +
     "It is a buoyancy aid, not a substitute for you. Always supervise."],
    ["How long is delivery?",
     "Ships within 24 hours on working days. Delivery takes 7 to 14 working days, free over $65."],
    ["Can I return it?",
     "30 days, money back, in resaleable condition. Swum in and dried is fine."]
  ];

  function css() {
    var s = document.createElement("style");
    s.textContent = [
      /* z-index 55 sits above ordinary page content (sticky bar is 40, the
         currency menu is 50) but below the two real modals — the mobile
         nav (60) and the cart drawer (70) — so the launcher never draws
         over their controls even for the one frame before the visibility
         sync below removes it entirely. */
      "#fc-help{position:fixed;right:16px;bottom:calc(20px + env(safe-area-inset-bottom));z-index:55;",
      "font-family:Archivo,'Helvetica Neue',sans-serif}",
      "@media(max-width:820px){#fc-help{bottom:calc(20px + env(safe-area-inset-bottom))}}",

      /* launcher — labelled, so it reads as help rather than as decoration */
      "#fc-help .btn{display:flex;align-items:center;gap:9px;height:52px;padding:0 20px 0 17px;",
      "border-radius:999px;border:0;cursor:pointer;background:#FFC53D;color:#05222B;",
      "font-family:Archivo,sans-serif;font-weight:700;font-size:12.5px;letter-spacing:.06em;",
      "text-transform:uppercase;box-shadow:0 12px 30px rgba(3,24,31,.34);",
      "transition:transform .18s ease,box-shadow .18s ease}",
      "#fc-help .btn:hover{transform:translateY(-2px);box-shadow:0 16px 36px rgba(3,24,31,.4)}",
      "#fc-help .btn:focus-visible{outline:3px solid #05222B;outline-offset:3px}",
      "#fc-help.on .btn{opacity:0;pointer-events:none}",

      /* scrim, phones only */
      "#fc-help .scrim{display:none}",

      /* panel */
      "#fc-help .panel{position:absolute;right:0;bottom:66px;width:min(370px,calc(100vw - 32px));",
      "background:#FCFEFE;border-radius:20px;box-shadow:0 26px 60px rgba(3,24,31,.32);overflow:hidden;",
      "opacity:0;transform:translateY(10px) scale(.98);pointer-events:none;",
      "transition:opacity .24s ease,transform .26s cubic-bezier(.2,.8,.2,1);",
      "max-height:min(72vh,580px);display:flex;flex-direction:column}",
      "#fc-help.on .panel{opacity:1;transform:none;pointer-events:auto}",
      /* the panel is focused on open so screen readers land inside it, but it
         is a container rather than a control, so it should not draw a ring */
      "#fc-help .panel:focus,#fc-help .panel:focus-visible{outline:none}",
      "#fc-help .grab{display:none}",

      /* header, with a close control that is actually there */
      "#fc-help .hd{background:#062A33;color:#EAF6F8;padding:17px 16px 17px 20px;display:flex;",
      "align-items:flex-start;justify-content:space-between;gap:12px}",
      "#fc-help .hd b{font-family:Anton,sans-serif;font-size:19px;letter-spacing:.03em;",
      "text-transform:uppercase;display:block}",
      "#fc-help .hd span{font-size:12px;line-height:1.5;color:#9FC0C9;display:block;margin-top:3px}",
      "#fc-help .x{flex:0 0 auto;width:36px;height:36px;border-radius:11px;border:0;cursor:pointer;",
      "background:rgba(255,255,255,.12);color:#EAF6F8;display:flex;align-items:center;justify-content:center}",
      "#fc-help .x:hover{background:rgba(255,255,255,.22)}",
      "#fc-help .x:focus-visible{outline:2px solid #FFC53D;outline-offset:2px}",

      /* one-tap shortcuts */
      "#fc-help .chips{display:flex;flex-wrap:wrap;gap:8px;padding:14px 20px 4px}",
      "#fc-help .chips a{display:inline-flex;align-items:center;gap:7px;min-height:38px;padding:0 14px;",
      "border-radius:999px;background:rgba(11,76,92,.08);color:#0B4C5C;text-decoration:none;",
      "font-size:12.5px;font-weight:600;transition:background .16s ease}",
      "#fc-help .chips a:hover{background:rgba(11,76,92,.16)}",
      "#fc-help .chips svg{opacity:.55}",

      "#fc-help .lbl{padding:16px 20px 6px;font-family:'JetBrains Mono',monospace;font-size:9.5px;",
      "letter-spacing:.18em;text-transform:uppercase;color:rgba(5,34,43,.5)}",

      "#fc-help .body{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:0 0 4px}",
      "#fc-help .q{border-top:1px solid rgba(5,34,43,.08)}",
      "#fc-help .q>button{width:100%;text-align:left;background:none;border:0;cursor:pointer;padding:14px 20px;",
      "font-family:Archivo,sans-serif;font-weight:600;font-size:13.5px;color:#05222B;display:flex;",
      "justify-content:space-between;gap:12px;align-items:center;min-height:48px}",
      "#fc-help .q>button:hover{background:rgba(5,34,43,.04)}",
      "#fc-help .q>button:focus-visible{outline:2px solid #0B4C5C;outline-offset:-2px}",
      "#fc-help .q .a{display:none;padding:0 20px 16px;font-size:13px;line-height:1.7;color:rgba(5,34,43,.78)}",
      "#fc-help .q.open .a{display:block}",
      "#fc-help .q .chev{transition:transform .2s ease;flex:0 0 auto;opacity:.5}",
      "#fc-help .q.open .chev{transform:rotate(180deg);opacity:1}",

      "#fc-help .ft{padding:14px 20px calc(18px + env(safe-area-inset-bottom));",
      "border-top:1px solid rgba(5,34,43,.08);display:flex;flex-direction:column;gap:8px;background:#FCFEFE}",
      "#fc-help .ft a{display:flex;align-items:center;justify-content:center;gap:10px;min-height:48px;",
      "border-radius:999px;text-decoration:none;font-weight:700;font-size:13px;letter-spacing:.03em;",
      "text-transform:uppercase}",
      "#fc-help .wa{background:#25D366;color:#05222B}",
      "#fc-help .em{background:#FFC53D;color:#05222B}",
      "#fc-help .note{font-size:11px;line-height:1.6;color:rgba(5,34,43,.62);text-align:center;margin-top:2px}",

      /* PHONES: a floating card is the wrong shape on a small screen.
         Bottom sheet, full width, grab handle, dimmed page behind. */
      "@media(max-width:720px){",
      "#fc-help .scrim{display:block;position:fixed;inset:0;background:rgba(3,24,31,.58);",
      "backdrop-filter:blur(2px);opacity:0;pointer-events:none;transition:opacity .26s ease;z-index:-1}",
      "#fc-help.on .scrim{opacity:1;pointer-events:auto}",
      "#fc-help .panel{position:fixed;left:0;right:0;bottom:0;width:auto;max-width:none;",
      "border-radius:22px 22px 0 0;max-height:86vh;transform:translateY(18px)}",
      "#fc-help.on .panel{transform:none}",
      "#fc-help .grab{display:block;width:42px;height:4px;border-radius:99px;background:rgba(255,255,255,.34);",
      "margin:10px auto 0}",
      "#fc-help .hd{padding-top:12px}",
      "#fc-help .btn{height:50px;font-size:12px}",
      "}",
      "@media(prefers-reduced-motion:reduce){#fc-help *{transition:none !important}}"
    ].join("");
    document.head.appendChild(s);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  var ARROW = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
              'stroke-width="2.4" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  function build() {
    var d = document.createElement("div");
    d.id = "fc-help";

    var links = "";
    if (WHATSAPP) {
      links += '<a class="wa" href="https://wa.me/' + esc(WHATSAPP) +
        '?text=' + encodeURIComponent("Hi, a question about the Float Club vest") +
        '" target="_blank" rel="noopener">WhatsApp us</a>';
    }
    if (EMAIL) {
      links += '<a class="em" href="mailto:' + esc(EMAIL) +
        '?subject=' + encodeURIComponent("Float Club question") + '">Email us</a>';
    }

    d.innerHTML =
      '<div class="scrim" data-close></div>' +
      '<div class="panel" role="dialog" aria-modal="true" aria-label="Help and contact" tabindex="-1">' +
        '<div class="grab" aria-hidden="true"></div>' +
        '<div class="hd">' +
          '<div><b>Need a hand?</b><span>Most answers are here. A person reads the rest.</span></div>' +
          '<button type="button" class="x" data-close aria-label="Close help">' +
            '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
            'stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="body">' +
          '<div class="chips">' +
            LINKS.map(function (l) {
              return '<a href="' + esc(l[1]) + '">' + esc(l[0]) + ARROW + '</a>';
            }).join("") +
          '</div>' +
          '<div class="lbl">Or read the short answer</div>' +
          FAQ.map(function (f, i) {
            return '<div class="q"><button type="button" data-q aria-expanded="false" ' +
              'aria-controls="fc-help-a' + i + '">' + esc(f[0]) +
              '<svg class="chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
              'stroke-width="2.4" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>' +
              '<div class="a" id="fc-help-a' + i + '">' + esc(f[1]) + '</div></div>';
          }).join("") +
        '</div>' +
        '<div class="ft">' + links +
        '<div class="note">We reply within one working day.</div></div>' +
      '</div>' +
      '<button class="btn" data-toggle aria-expanded="false">' +
        '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="#05222B" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.1A8.4 8.4 0 0 1 4 11.5a8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 8 8.4Z"/></svg>' +
        '<span>Help</span>' +
      '</button>';

    document.body.appendChild(d);
    return d;
  }

  function focusables() {
    return [].slice.call(root.querySelectorAll(
      '.panel a[href], .panel button:not([disabled])'
    ));
  }

  function toggle(force) {
    open = (force === undefined) ? !open : force;
    root.classList.toggle("on", open);
    root.querySelector("[data-toggle]").setAttribute("aria-expanded", open ? "true" : "false");

    var panel = root.querySelector(".panel");
    /* hidden from assistive tech and from Tab when closed, rather than
       sitting invisibly in the tab order behind the page */
    panel.setAttribute("aria-hidden", open ? "false" : "true");

    if (open) {
      lastFocus = document.activeElement;
      panel.focus();
      /* the page behind should not scroll under an open sheet */
      if (window.matchMedia("(max-width:720px)").matches) {
        document.body.style.overflow = "hidden";
      }
    } else {
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  /* -----------------------------------------------------------------
     OVERLAY GUARD — the launcher must never sit on top of the cart
     drawer (#fc-drawer, z-index 70) or the mobile nav (#fc-mnav,
     z-index 60). Both toggle by writing straight to their own inline
     style.display (see fc-commerce.js openDrawer/closeDrawer and the
     openNav/closeNav pair in index.html), and #fc-mnav additionally
     flips a data-open attribute. A MutationObserver on those two
     elements is the one place that is guaranteed to see every open and
     close, however it happens, without fc-help.js needing to know how
     each drawer works.
  --------------------------------------------------------------------- */
  function overlayOpen() {
    var drawer = document.getElementById("fc-drawer");
    var mnav = document.getElementById("fc-mnav");
    var drawerOpen = !!(drawer && drawer.style.display === "block");
    var mnavOpen = !!(mnav && (mnav.style.display === "block" || mnav.getAttribute("data-open") === "true"));
    return drawerOpen || mnavOpen;
  }

  function syncVisibility() {
    if (!root) return;
    var hide = overlayOpen();
    // force the help panel itself shut rather than leaving it open behind
    // a hidden launcher with no way to close it
    if (hide && open) toggle(false);
    root.style.display = hide ? "none" : "";
  }

  function watchOverlays() {
    var targets = [document.getElementById("fc-drawer"), document.getElementById("fc-mnav")];
    var mo = new MutationObserver(syncVisibility);
    targets.forEach(function (t) {
      if (t) mo.observe(t, { attributes: true, attributeFilter: ["style", "data-open"] });
    });
    syncVisibility();
  }

  function init() {
    css();
    root = build();
    root.querySelector(".panel").setAttribute("aria-hidden", "true");
    watchOverlays();

    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-toggle]")) { toggle(); return; }
      if (e.target.closest("[data-close]")) { toggle(false); return; }
      var q = e.target.closest("[data-q]");
      if (q) {
        var row = q.parentElement;
        var now = !row.classList.contains("open");
        row.classList.toggle("open", now);
        q.setAttribute("aria-expanded", now ? "true" : "false");
      }
    });

    document.addEventListener("click", function (e) {
      if (open && !e.target.closest("#fc-help")) toggle(false);
    });

    document.addEventListener("keydown", function (e) {
      if (!open) return;
      if (e.key === "Escape") { toggle(false); return; }
      if (e.key !== "Tab") return;
      /* keep Tab inside the panel while it is open */
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  global.FC_HELP = { open: function () { toggle(true); }, close: function () { toggle(false); } };

})(window);
